export * from './api';
export * from './partnerType';

export const CORE_CURRENT_USER_KEY = 'current-user';
export const CORE_GET_USER_SETTINGS_KEY = 'get-user-settings';
export const CORE_UPDATE_CURRENT_USER_KEY = 'update-current-user';
export const CORE_UPDATE_USER_SETTINGS_KEY = 'update-user-settings';

export const HEADER_DROPDOWN_OPTIONS = {
  TEAM_MANAGEMENT: 'team-management',
  MY_ACCOUNT: 'my-account',
  STUDY_INSIGHTS: 'study-insights',
  LOG_OUT: 'logout',
};
